import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, staggerChildren: 0.18 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } }
};

const TeamStatsSection = () => (
  <motion.section
    className="w-full bg-white py-16 font-sans"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.4 }}
    variants={containerVariants}
  >
    <div className="max-w-4xl mx-auto px-4 md:px-0">
      <motion.h2
        className="text-3xl md:text-5xl font-medium text-center mb-6"
        style={{ fontFamily: 'Inter, sans-serif' }}
        variants={itemVariants}
      >
        The Team Behind<br />Our Global Talent Mission
      </motion.h2>

      <motion.p
        className="text-lg text-center text-black mb-12"
        style={{ fontFamily: 'Inter, sans-serif' }}
        variants={itemVariants}
      >
        Driven by passion, built on diversity, delivering recruitment excellence.
      </motion.p>

      <motion.div className="border-t border-b border-gray-950" variants={containerVariants}>
        <div className="flex flex-col divide-y divide-gray-950">
          <motion.div className="flex flex-col md:grid md:grid-cols-2 py-8 md:py-10 md:divide-x md:divide-gray-950" variants={itemVariants}>
            <div className="flex flex-col items-center justify-center mb-4 md:mb-0">
              <span className="text-5xl md:text-6xl font-normal">30+</span>
            </div>
            <div className="flex flex-col items-center md:items-start justify-center px-0 md:px-6">
              <span className="text-base md:text-lg text-black text-center md:text-left max-w-xs md:max-w-none">
                30+ talented professionals delivering precision recruitment at global scale.
              </span>
            </div>
          </motion.div>

          <motion.div className="flex flex-col md:grid md:grid-cols-2 py-8 md:py-10 md:divide-x md:divide-gray-950" variants={itemVariants}>
            <div className="flex flex-col items-center md:items-start justify-center px-0 md:px-6 mt-4 md:mt-0">
              <span className="text-base md:text-lg text-black text-center md:text-left max-w-xs md:max-w-none">
                A diverse team united from 7+ nationalities across the globe.
              </span>
            </div>
            <div className="flex flex-col items-center justify-center mb-4 md:mb-0">
              <span className="text-5xl md:text-6xl font-normal">7+</span>
            </div>
          </motion.div>

          <motion.div className="flex flex-col md:grid md:grid-cols-2 py-8 md:py-10 md:divide-x md:divide-gray-950" variants={itemVariants}>
            <div className="flex flex-col items-center justify-center mb-4 md:mb-0">
              <span className="text-5xl md:text-6xl font-normal">14</span>
            </div>
            <div className="flex flex-col items-center md:items-start justify-center px-0 md:px-6">
              <span className="text-base md:text-lg text-black text-center md:text-left max-w-xs md:max-w-none">
                We speak 14 languages to connect talent across every market.
              </span>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  </motion.section>
);

export default TeamStatsSection;
